<script>
import Base from './base.vue';
import autoAdd from '../mixin/auto-add';
import { flowTypes } from '@/common/service/page-config';
import modalMixin from '@/views/modal/modal-mx.js';
import plansMixin from '@/plans/mx/plan';
import { planTypes } from '@/common/constants';

export default {
  name: 'BUY_NOW',
  extends: Base,
  mixins: [autoAdd, modalMixin, plansMixin],
  data() {
    return {
      isExpanded: true, // Override plansMixin's isExpanded: false to keep card expanded by default
      bd_planType: planTypes.ZOOM_ONE_BUNDLE,
    }
  },
  computed: {
    showIncreaseWithLargeMeetingPromo() {
      if (!window.$isEnabled('enableIncreaseWithLargeMeetingPromo')) {
        return false;
      }
      return [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        !this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') &&
        this.$core.addonFilterKeys.includes('LARGE_MEETING') &&
        !this.isInClientModal
    },
    showLargeMeetingPromoInComparison() {
      return [flowTypes.buyNow, flowTypes.basic2pro].includes(this.$context.flow) &&
        !this.isInClientModal &&
        (
          this.$core.draftPlanFilterKeys.includes('LARGE_MEETING') ||
          this.$core.addonFilterKeys.includes('LARGE_MEETING')
        )
    },
  },
};
</script>
